export const getMarkets = () => {
    return ['en', 'sk', 'cz'];
};
